import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { topRated } from '@/mocks/movies';

export default function TopRatedSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif">
              <i className="ri-star-line text-accent-500 mr-2"></i>
              高分佳作
            </h2>
            <p className="text-sm text-foreground-500 mt-1">豆瓣高分影视作品，每一部都是经典</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {topRated.map((movie) => (
            <div key={movie.id} className="relative">
              <MovieCard movie={movie} size="normal" />
            </div>
          ))}
        </div>

        <Link
          to="/category/all"
          className="sm:hidden flex items-center justify-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          查看全部高分佳作
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}